// extracted by mini-css-extract-plugin
module.exports = {"caption":"styles_caption__Uoeem","articlePreview":"styles_articlePreview__1iclj"};